import { Component, Input, output } from '@angular/core';

import { FollowButtonComponent } from '@core/candidate-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import type { Requisition } from '@core/requisitions-types';
import { RequisitionStatus } from '@core/requisitions-types';
import {
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  GroupComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisition-table-row-actions',
  styleUrls: ['./requisition-table-row-actions.component.less'],
  templateUrl: './requisition-table-row-actions.component.html',
  imports: [
    IconButtonComponent,
    GroupComponent,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    ConnectedOverlayDirective,
    TranslatePipe,
    OverlayOriginDirective,
    FollowButtonComponent,
  ],
})
export class RequisitionTableRowActionsComponent {
  @Input() public requisition: Requisition;
  @Input() public canEditRequisition: boolean;

  public follow = output<number>();
  public unfollow = output<number>();
  public cancelRequest = output<number>();
  public duplicate = output<number>();
  public delete = output<Requisition>();
  public archive = output<Requisition>();
  public retrieve = output<Requisition>();
  public openRequisition = output<number>();

  public DropdownWidth = DropdownWidth;
  public RequisitionStatus: typeof RequisitionStatus = RequisitionStatus;
}
